import { Icon, Record } from './record';

export interface PurchaseSuggestion {
  id?: number;
  clientCode?: number;
  userId: string;
  nInf: string;
  title: string;
  author: string;
  creationDate?: number;
  modificationDate?: number;
  status?: SuggestionStatus;
  coverUrl?: string;
  resourceTypes?: string[];
  icon?: Icon;
  record?: Record;
}

export enum SuggestionStatus {
  WAITING = 'WAITING',
  BOUGHT = 'BOUGHT',
  ERASED = 'ERASED',
  REFUSED = 'REFUSED',
}
